import { Box, Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { ApplyModule } from '../../store/features/apply/types';
import { StrOrNum } from '../../types/util';
import { PreviewApplyItem } from './PreviewApplyItem';
import { SelectedApplyItem } from './types';

interface PreviewApplyListProps {
  selectedItems: SelectedApplyItem[];
  renderApplyBtn: () => React.ReactElement;
  onRemove: (id: StrOrNum) => void;
  module: ApplyModule;
  onCloseBtnClick: () => void;
}
export const PreviewApplyList: React.FC<PreviewApplyListProps> = ({
  selectedItems,
  renderApplyBtn,
  onRemove,
  module,
  onCloseBtnClick,
}) => {
  const moduleTitle = module === 'institute_programs' ? 'Programs' : 'Scholarships';

  const _onRemove = (id: StrOrNum) => {
    onRemove(id);
    if (selectedItems.length === 1) {
      onCloseBtnClick();
    }
  };

  return (
    <>
      <DialogTitle sx={{ py: 1.5 }}>
        <Typography variant="medium" fontWeight="Medium">
          {selectedItems.length} {moduleTitle} Selected for Apply
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          {selectedItems.map((selectedItem) => (
            <PreviewApplyItem key={selectedItem.id} item={selectedItem} onRemove={() => _onRemove(selectedItem.id)} />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Grid justifyContent="flex-end" container spacing={1.5}>
          <Grid item>
            <Button onClick={onCloseBtnClick} variant="default">
              Close
            </Button>
          </Grid>
          <Grid item>{renderApplyBtn()}</Grid>
        </Grid>
      </DialogActions>
    </>
  );
};
